import React from 'react';
import { Navigate } from 'react-router-dom';
import { Typography } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { hasFileManagerAccess } from '../../constants/accessControl';

const { Text } = Typography;

interface FileManagementRouteProps {
  children: React.ReactNode;
}

const FileManagementRoute: React.FC<FileManagementRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <Text style={{ fontSize: 16 }}>Loading...</Text>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user email is in allowed list
  const hasAccess = hasFileManagerAccess(user?.email);

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default FileManagementRoute;

